import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { Progress, Spinner } from "reactstrap";

const ProgressCalculator = ({
    t,
    totalCount,
    processedCount,
    rejectedCount,
    waitingCount
}) => {
    const totalProcessed = processedCount + rejectedCount

    return (
        <div className="ai-onboarding-progress">
            <div className="text-left mb-1">
                {totalProcessed === totalCount ? (
                    <i className="ri-check-double-fill font-size-20 text-success align-middle me-1" />
                ) : (
                    <Spinner 
                        className="me-1"
                        size="sm" 
                        color="primary" 
                    />
                )}
                
                {`${totalProcessed} ${t('of')} ${totalCount} ${t('entries processed')}`}
            </div>
            <Progress
                animated
                style={{
                    height: '16px'
                }}
                max={!totalProcessed ? 0 : totalCount}
                value={totalProcessed}
            >
                {`${totalCount ? Math.round(totalProcessed / totalCount * 100) : 0}%`}
            </Progress>
        </div>
    )
}

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    return {
        token         :   token
    };
};

export default withNamespaces()(
    withRouter(connect(
        mapStatetoProps,
        {}
    )(ProgressCalculator))
)